module.exports = __webpack_public_path__ + "static/media/crane1.70083fb1.png";